import React, { PureComponent } from 'react';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';

import EnhancedTextField from 'embeds/components/EnhancedTextField';
import { CodeEditor } from 'embeds/components';

class FormEnhancedTextField extends PureComponent {
  // to prevent delay/bad performance when typing into the code editor component
  handleChange = debounce((value) => {
    const {
      input: { onChange },
    } = this.props;
    onChange(value);
  }, 300);

  render() {
    const {
      externalTemplateAdded,
      helperText,
      hintText,
      useCodeEditor = false,
      input: { name, onBlur, onChange, value },
      meta: { error, touched },
      ...other
    } = this.props;
    const hasError = touched && !!error;
    const errorText = hasError ? error : null;

    return useCodeEditor ? (
      <CodeEditor onChange={this.handleChange} value={value} placeholder={hintText || 'Enter message'} name={name} />
    ) : (
      <EnhancedTextField
        error={hasError}
        externalTemplateAdded={externalTemplateAdded}
        helperText={errorText || helperText}
        hintText={hintText || 'Enter message'}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
        {...other}
        // https://github.com/react-dnd/react-dnd/issues/701
        onDrop={(e) => e.preventDefault()}
      />
    );
  }
}

FormEnhancedTextField.defaultProps = {
  useCodeEditor: false,
};

FormEnhancedTextField.propTypes = {
  externalTemplateAdded: PropTypes.string,
  helperText: PropTypes.string,
  hintText: PropTypes.string,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  onInfoUpdated: PropTypes.func,
  squigglyTemplates: PropTypes.array.isRequired,
  useCodeEditor: PropTypes.bool,
};

export default FormEnhancedTextField;
